import { Table, message, Image, Form, Input, Space, DatePicker, Divider, Select, Tooltip, Button, InputNumber, Modal } from 'antd';
import debounce from 'lodash/debounce';
import APIUtils from '../../api/APIUtils';
import WebLinks from '../../api/WebLinks';
import { useEffect, useState, useRef, useContext } from 'react';
import constants from '../../constants/constants';
import Cookies from 'js-cookie';
import moment from 'moment';
import { CommonContext, CurrencyContext } from '../../Context';
import dayjs from 'dayjs';
import { getCurrencyName } from '../../globalFunctions/GlobalFunctions';
const { Column } = Table;
const { Option } = Select;
const { TextArea } = Input;

const OrdersAdminLiveContracts = (props) => {
	//Variable Declaration
	const currencyContext=useContext(CurrencyContext);
	const [ordersData, setOrdersData] = useState([]);
	const [loading, setloading] = useState(false);
	const [rangePickerValue, setRangePickerValue] = useState([]);
	const [pagination, setPagination] = useState({ current: 1, pageSize: 200, total: 0 });
	const [suplierListLoader,setSuplierListLoader]= useState(false);
	const [buyerListLoader,setBuyerListLoader]= useState(false);
	const [buyerBillingListLoader,setBuyerBillingListLoader]= useState(false);
	const [allowedBuyerList, setAllowedBuyerList] = useState([]);
  const [allowedSupplierCSList, setAllowedSupplierCSList] = useState([]);
  const [buyerBillingList, setBuyerBillingList] = useState([]);
  const [productsOrderList, setProductsOrderList] = useState([]);
  const [selectedBuyerIds,setSelectedBuyerIds]=useState(null);
  const [productsListLoader, setProductsListLoader] = useState(false);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [sorterState, setSorterState] = useState({ field: null, order: null });
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [contract,setContract]=useState("");
  const [billing,setBilling]=useState("");
  const [showBilling,setShowBilling]=useState("f");
	const [form] = Form.useForm();
  const [formCreate] = Form.useForm();
    const commonContext=useContext(CommonContext);
    const buyerId = commonContext.common.buyerId;
  const tableRef = useRef(null);

  // Table columns
  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) =>
        (a?.id ?? 0) - (b?.id ?? 0)
    },
    {
      title: 'Buyer',
      dataIndex: 'buyerName',
      key: 'buyerName',
    },
		{
			title: 'Contract Start',
			dataIndex: 'startOfContract',
			key: 'startOfContract',
			render: (startOfContract) => {
				{return<span className='whitespace-nowrap'><p>{moment(startOfContract ).format('YYYY-MM-D')}</p></span>}
			},
			sorter: (a, b) => moment(a.startOfContract ).unix() - moment(b.startOfContract ).unix(),
		},
		{
			title: 'Contract End',
			dataIndex: 'endOfContract',
			key: 'endOfContract',
			render: (endOfContract) => {
					{return<span className='whitespace-nowrap'><p>{moment(endOfContract ).format('YYYY-MM-D')}</p></span>}
			},
			sorter: (a, b) => moment(a.endOfContract ).unix() - moment(b.endOfContract ).unix(),
		},
    {
      title: 'Contract Period',
      dataIndex: 'contractPeriod',
      key: 'contractPeriod',
      sorter: (a, b) => a.contractPeriod.localeCompare(b.contractPeriod),
    },
    {
			title:"Suppliers",
			dataIndex: 'suppliers',
			key: 'suppliers',
			width: '20%',
			render: (text, record, index) =>
			<>
				{ record.logoURL && record.logoURL!==""? <Image src={record.logoURL} preview={false} width={100}/> : <span className='uppercase font-bold text-gray-400'>{record.supplierName} </span>}
			</>
		},
    {
      title: 'Product',
      dataIndex: 'productName',
      key: 'productName',
      sorter: (a, b) => a.productName  - b.productName ,
    },
    {
      title: 'Product Type',
      dataIndex: 'productType',
      key: 'productType',
      sorter: (a, b) => a.productType - b.productType,
    },
    {
      title: 'PO',
      dataIndex: 'purchaseOrderInfo',
      key: 'purchaseOrderInfo',
      sorter: (a, b) => a.purchaseOrderInfo.localeCompare(b.purchaseOrderInfo),
    },
    {
      title: 'Invoice Currency',
      dataIndex: 'invoiceCurrency',
      key: 'invoiceCurrency',
      //sorter: (a, b) => a.invoiceCurrency - b.invoiceCurrency,
    },
    {
      title: 'Contract Amount',
      dataIndex: 'invoiceAmount',
      key: 'invoiceAmount',
      sorter: (a, b) => a.invoiceAmount - b.invoiceAmount,
    },
		{
      title: 'Created By',
      dataIndex: 'createdBy',
      key: 'createdBy',
    },
    // {
    //   title: 'CS Name',
    //   dataIndex: 'customerSuccessName',
    //   key: 'customerSuccessName',
    // },
  ];

	//On page load
	useEffect(() => {
		form.setFieldsValue({ contractStart: null, contractEnd: null });
		setRangePickerValue([]);
		const sortBy = getSortBy(sorterState.field);
		const sortDesc = sorterState.order === 'descend';
		fetchData([], null, null, 1, 200, sortBy, sortBy ? sortDesc : null);
		getAllowedBuyers();
    getAllowedSuppliers();
    getAllOrderProducts();
    getBuyersBillingEnabled();
	}, [props]);

	//Functions
	//Function to fetch orders data
	const fetchData = async (dateRange, buyerids, productids, currentPage = 1, pageSize = 200, sortBy = null, sortDesc = null) => {
		setloading(true);
		let url = WebLinks.GetContractAdminLiveProducts;
		const contractStart = Array.isArray(dateRange) && dateRange.length ? dateRange[0] : null;
		const contractEnd = Array.isArray(dateRange) && dateRange.length > 1 ? dateRange[1] : null;
		if (buyerids) {
			url += `${url.includes("?") ? "&" : "?"}buyerId=${buyerids}`;
		}
		if (productids?.length) {
			url += `${url.includes("?") ? "&" : "?"}productId=${productids.join(",")}`;
		}
    if (contractStart) {
      url += `${url.includes("?") ? "&" : "?"}contractStartDate=${dayjs(contractStart).format(constants.DateFormat2)}`;
    }
    if (contractEnd) {
      url += `${url.includes("?") ? "&" : "?"}contractEndDate=${dayjs(contractEnd).format(constants.DateFormat2)}`;
    }
		url += `${url.includes("?") ? "&" : "?"}limit=${pageSize}&pageNo=${currentPage}`;
		if (sortBy) {
			url += `&sortBy=${sortBy}&sortDesc=${sortDesc}`;
		}
		const orders = await APIUtils.apiCall("GET", url, null);
		if (orders.isCatch) {
			message.error(constants.ERROR_MESSAGE);
		} else {
			if (orders.resultObj?.statusCode === "2000") {
				setOrdersData(orders?.resultObj?.data || []);
				const totalRecords = orders.resultObj?.getCount ?? orders.resultObj?.totalCount ?? (orders.resultObj?.data?.length || 0);
				setPagination((prev) => ({
					...prev,
					current: currentPage,
					pageSize,
					total: totalRecords,
				}));
			} else {
				setOrdersData([]);
				setPagination((prev) => ({ ...prev, total: 0 }));
				message.error(orders.resultObj?.message || constants.ERROR_MESSAGE);
			}
		}
		setloading(false);
	}

	//Function to get Allowed Buyers list
	const getAllowedBuyers =async()=>{
		setBuyerListLoader(true);
    const response = await APIUtils.apiCall('GET', WebLinks.SubBuyerList + Cookies.get(constants.COOKIE_LOGGED_BUYER_ID));
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			setAllowedBuyerList(response?.resultObj?.data||[])
			setBuyerListLoader(false);
		}else{
			setAllowedBuyerList([]);
			setBuyerListLoader(false);
			message.error(response.resultObj.message);
		}
	}

  //Function to get Allowed suppliers list
	const getAllowedSuppliers =async()=>{
		setSuplierListLoader(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GetALlAllowedSuppliersAllowedOrders);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			setAllowedSupplierCSList(response?.resultObj?.data||[])
			setSuplierListLoader(false);
		}else{
			setAllowedSupplierCSList([]);
			setSuplierListLoader(false);
			message.error(response.resultObj.message);
		}
	}

	//Function to get buyers billing enables
	const getBuyersBillingEnabled =async()=>{
    setBuyerBillingListLoader(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GetBuyerCSBillingList);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			setBuyerBillingList(response?.resultObj?.data||[])
      setBuyerBillingListLoader(false);
		}else{
			setBuyerBillingList([]);
      setBuyerBillingListLoader(false);
			message.error(response.resultObj.message);
		}
	}

  //Function to get order products
  const getAllOrderProducts= async()=>{
    setProductsListLoader(true);
    const response = await APIUtils.apiCall('GET',WebLinks.GetOrderProductList);
    if(!response.isCatch && response.resultObj.statusCode==="2000"){
      setProductsOrderList(response?.resultObj?.data||[])
      setProductsListLoader(false);
    }else{
      setProductsOrderList([]);
      setProductsListLoader(false);
      message.error(response.resultObj.message);
    }
  }
 	const getSortBy = (field) => {
		switch (field) {
			case 'startOfContract':
				return 'ContractStartDate';
			case 'endOfContract':
				return 'ContractEndDate';
			case 'contractPeriod':
				return 'ContractPeriod';
			case 'purchaseOrderInfo':
				return 'PurchaseOrderInfo';
			case 'invoiceCurrency':
				return 'InvoiceCurrency';
			case 'invoiceAmount':
				return 'InvoiceAmount';
			case 'createdBy':
				return 'CreatedByBuyerId';
			default:
				return null;
		}
	};

	// Function to handle table pagination and sorting changes
	const handleTableChange = (paginationInfo, filters, sorter) => {
		if (!paginationInfo) return;
		const sortBy = getSortBy(sorter?.field);
		const sortDesc = sorter?.order === 'descend';
		setSorterState({ field: sorter?.field || null, order: sorter?.order || null });
		fetchData(
			rangePickerValue,
			selectedBuyerIds,
			selectedProductIds,
			paginationInfo.current,
			paginationInfo.pageSize,
			sortBy,
			sortBy ? sortDesc : null
		);
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	//Function on change of supplier selection
  const handleBuyersSelect = (selectedBuyer) => {
    const sortBy = getSortBy(sorterState.field);
    const sortDesc = sorterState.order === 'descend';
    if (selectedBuyer && selectedBuyer !== "showall") {
      setSelectedBuyerIds(selectedBuyer);
      form.setFieldsValue({
        buyerList: selectedBuyer
      });
      setPagination((prev) => ({ ...prev, current: 1 }));
      fetchData(rangePickerValue, selectedBuyer, selectedProductIds, 1, pagination.pageSize, sortBy, sortBy ? sortDesc : null);
    } else {
      setSelectedBuyerIds(null);
      form.setFieldsValue({
        buyerList:"showall"
      });
      setPagination((prev) => ({ ...prev, current: 1 }));
      fetchData(rangePickerValue, null, selectedProductIds, 1, pagination.pageSize, sortBy, sortBy ? sortDesc : null);
    }
  };
  //Function on change of product selection
  const handleProductSelect = (selectedProducts) => {
    const sortBy = getSortBy(sorterState.field);
    const sortDesc = sorterState.order === 'descend';
    if (selectedProducts.length > 0) {
      let tempSelectedProducts = selectedProducts.filter(value => value !== 'showall');
      let selectedProductsFinal = tempSelectedProducts.length > 0 ? tempSelectedProducts : "";
      form.setFieldsValue({
        productsList: selectedProductsFinal
      })
      setSelectedProductIds(selectedProductsFinal);
      setPagination((prev) => ({ ...prev, current: 1 }));
      fetchData(rangePickerValue, selectedBuyerIds, selectedProductsFinal, 1, pagination.pageSize, sortBy, sortBy ? sortDesc : null);
    } else {
      form.setFieldsValue({
        productsList: ["showall"]
      })
      setSelectedProductIds([]);
      setPagination((prev) => ({ ...prev, current: 1 }));
      fetchData(rangePickerValue, selectedBuyerIds, null, 1, pagination.pageSize, sortBy, sortBy ? sortDesc : null);
    }
  }

	const RangeStartChanged = debounce((date, dateString) => {
		const sortBy = getSortBy(sorterState.field);
		const sortDesc = sorterState.order === 'descend';
		const start = dateString || null;
		const current = Array.isArray(rangePickerValue) ? [...rangePickerValue] : [];
		current[0] = start;
		const normalizedDates = current;
		setRangePickerValue(normalizedDates);
		setPagination((prev) => ({ ...prev, current: 1 }));
		fetchData(normalizedDates, selectedBuyerIds, selectedProductIds, 1, pagination.pageSize, sortBy, sortBy ? sortDesc : null);
	}, 500);
	const RangeEndChanged = debounce((date, dateString) => {
		const sortBy = getSortBy(sorterState.field);
		const sortDesc = sorterState.order === 'descend';
		const end = dateString || null;
		const current = Array.isArray(rangePickerValue) ? [...rangePickerValue] : [];
		current[1] = end;
		const normalizedDates = current;
		setRangePickerValue(normalizedDates);
		setPagination((prev) => ({ ...prev, current: 1 }));
		fetchData(normalizedDates, selectedBuyerIds, selectedProductIds, 1, pagination.pageSize, sortBy, sortBy ? sortDesc : null);
	}, 500);

  //Function to save edited job
  const saveDetails = async (values) => {
    let payload = {
      //buyerId: Cookies.get(constants.COOKIE_SELECTED_BUYER_ID),
      buyerId: values?.buyersSelected,
      supplierId: values?.supplier,
      productId: values?.orderProductId,
      billingDateStart: dayjs(values?.contractDatePicker).format(constants.DateFormat2),
      billingDateEnd: dayjs(values?.contractDatePicker).format(constants.DateFormat2),
      buyerOrderProductId: values?.orderProductId,
      contractPeriod: values?.contractPeriod,
      billingPeriod: values?.billingPeriod,
      invoiceCurrency: values?.invoiceCurrency,
      invoiceAmount: values?.invoiceAmt,
      contractAmount: values?.contractAmount,
      createdByBuyerId: Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
      contractStartDate:dayjs(values?.contractDatePicker).format(constants.DateFormat2),
      contractEndDate: dayjs(values?.contractDatePicker).format(constants.DateFormat2),
      purchaseOrderInfo: values?.orderInfo,
      notesToIssuer:values?.noteToIssuer,
    }
 
    let method, url, body;
    method = "POST";
    url = WebLinks.AddOrderDetails;
    const response = await APIUtils.apiCall(method, url,JSON.stringify(payload));
    if (!response.isCatch || response.resultObj.statusCode === "2000") {
      handleCancel();
      message.success(response.resultObj.message);
      const sortBy = getSortBy(sorterState.field);
      const sortDesc = sorterState.order === 'descend';
      fetchData(rangePickerValue, selectedBuyerIds, selectedProductIds, 1, pagination.pageSize, sortBy, sortBy ? sortDesc : null);
    } else {
      handleCancel();
      message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
    }
  };

  const handleCancel = () => {
    formCreate.resetFields();
    setIsEditModalOpen(false);
  };

  //on Contact change
  const onContractChange=(e)=>{
    setContract(e);
    setBilling(e);
    resetInvoiveAmount();
    formCreate.setFieldsValue({
      billingPeriod: e
    })
    if(e==="Monthly" || e==="One Off"){
      setShowBilling("t");
    }else{
      setShowBilling("f")
    }
  }

  //Set default currency
  const setDefaultCurrency=()=>{
    let curr=getCurrencyName(currencyContext.currency);
    formCreate.setFieldsValue({
      invoiceCurrency:curr
    })
  };

  //Set Invoice amount
  const setInvoiceAmount=(val)=>{
    let tempInvoiceVal=0;
    if(billing!==""&&contract!==""){
      if(billing===contract){
        tempInvoiceVal=val;
      }else if(billing==="Monthly"&&contract==="Quarterly"){
        tempInvoiceVal=val/3;
      }else if(billing==="Monthly" && contract==="Annually"){
        tempInvoiceVal=val/12;
      }else if(billing==="Quarterly" && contract==="Annually"){
        tempInvoiceVal=val/4;
      }else if(billing==="SixMonthly" && contract==="Annually"){
        tempInvoiceVal=val/2;
      }else if(billing==="Monthly" && contract==="TwoMonthly"){
        tempInvoiceVal=val/2;
      }else if(billing==="TwoMonthly" && contract==="SixMonthly"){
        tempInvoiceVal=val/3;
      }else if(billing==="Quarterly" && contract==="SixMonthly"){
        tempInvoiceVal=val/2;
      }else if(billing==="Monthly" && contract==="SixMonthly"){
        tempInvoiceVal=val/6;
      }else if(billing==="Annually" && contract==="TwoYearly"){
        tempInvoiceVal=val/2;
      }else if(billing==="SixMonthly" && contract==="TwoYearly"){
        tempInvoiceVal=val/4;
      }else if(billing==="Quarterly" && contract==="TwoYearly"){
        tempInvoiceVal=val/8;
      }else if(billing==="Monthly" && contract==="TwoYearly"){
        tempInvoiceVal=val/24;
      }else if(billing==="Annually" && contract==="ThreeYearly"){
        tempInvoiceVal=val/3;
      }else if(billing==="SixMonthly" && contract==="ThreeYearly"){
        tempInvoiceVal=val/6;
      }else if(billing==="Quarterly" && contract==="ThreeYearly"){
        tempInvoiceVal=val/12;
      }else if(billing==="Monthly" && contract==="ThreeYearly"){
        tempInvoiceVal=val/36;
      }else{
        tempInvoiceVal=val;
      }
      formCreate.setFieldsValue({
        invoiceAmt: parseFloat(Number(tempInvoiceVal).toFixed(2))
      })
    }else{
      resetInvoiveAmount();
      message.error("Please select billing/contract period.")
    }
  };
  const resetInvoiveAmount=()=>{
    formCreate.setFieldsValue({
      invoiceAmt:[],
      contractAmount:[]
    })
  };
	//Render
	return (
    <>
    <div className='uppercase font-bold text-xl'>CS REP LIVE contracts</div>
			<Divider className='my-3'/>
		<div>
			<div className='flex flex-wrap gap-3 justify-between items-center mb-3'>
				<Space wrap>
          <Form form={form}>
            <Space wrap>
              <Form.Item name="contractStart" className='mb-0'>
                <DatePicker
                  placeholder={"Start Date"}
                  onChange={RangeStartChanged}
                  format={constants.DateFormat2}
                />
              </Form.Item>
              <Form.Item name="contractEnd" className='mb-0'>
                <DatePicker
                  placeholder={"End Date"}
                  onChange={RangeEndChanged}
                  format={constants.DateFormat2}
                />
              </Form.Item>
            <Tooltip title="Buyers">
						<Form.Item name="buyerList" className='mb-0'>
              <Select
                loading={buyerListLoader}
                className='!w-60'
                // value={selectedSupplier || []}
                placeholder={constants.buyerName}
                
                allowClear
                defaultValue={"showall"}
                showSearch
              filterOption={(input, option) =>
                  option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
                onChange={handleBuyersSelect}
                >
                  <Option key='showall' value='showall'>Show all</Option>
                    {allowedBuyerList?.map((buyer) => (
                      <Option key={buyer.subPartnerId}
                        value={buyer.subPartnerId}
                      >
                      {buyer.name}
                  </Option>
                ))}
              </Select>
            </Form.Item></Tooltip>
            <Tooltip title="Products">
              <Form.Item name="productsList" className='mb-0'>
                <Select
                  loading={productsListLoader}
                  className='!w-60'
                  placeholder={"Products"}
                  mode='multiple'
                  allowClear
                  defaultValue={"showall"}
                  showSearch
                  filterOption={(input, option) =>
                    option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(e) => handleProductSelect(e)}
                >
                  <Option key='showall' value='showall'>Show all</Option>
                  {productsOrderList?.map((product) => (
                    <Option key={product.id}
                      value={product.id}
                    >
                      {product.productName}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Tooltip>
						</Space>
					</Form>
          <Tooltip placement='right' title={constants.CreatOrder}>
            <Button  onClick={(e) => { setIsEditModalOpen(true);setDefaultCurrency()}}  className="bg-green-800 text-white hover:!text-white hover:!border-green-500" > {constants.CreatOrder}</Button>
          </Tooltip>
				</Space>
			</div>
			<div className='overflow-x-auto mt-4 mb-4' ref={tableRef}>
			<Table
        size="small"
        loading={loading}
        onRow={(record) => ({
          className: record.billingPostPay ? "billing-post-pay-row" : "",
          style: record.billingPostPay
            ? { backgroundColor: "#fef3c7" }
            : undefined,
        })}
        columns={columns}
        dataSource={ordersData}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["200", "500", "1000", "2000"],
        }}
        onChange={handleTableChange}
        />
			</div>
      <Modal
        title={"Create Order"}
        open={isEditModalOpen}
        onCancel={handleCancel}
        destroyOnClose
        style={{ top: 20 }}
        width={800}
        footer={
          [
          <Button key="cancel" onClick={()=>handleCancel()}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={()=>formCreate.submit()}>
            Save
          </Button>,
        ]
      }
      >
        <Form form={formCreate} name="form_in_modal" layout="vertical" onFinish={saveDetails}>
          <div className="grid xs:grid-cols-1 lg:grid-cols-2 gap-4">
          <Form.Item
              name="buyersSelected"
              label="Buyer"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select loading={buyerBillingListLoader} onChange={()=>setDefaultCurrency()} placeholder="Select Buyer"
              showSearch
              filterOption={(input, option) =>
                  option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
              {buyerBillingList?.map((supplier) => (
                      <Option key={supplier.id}
                          value={supplier.id}
                      >
                      {supplier.buyerName}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="supplier"
              label="Supplier"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select loading={suplierListLoader} onChange={()=>setDefaultCurrency()} placeholder="Select Supplier"
              showSearch
              filterOption={(input, option) =>
                  option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option key={50} value={50}>Mixed Media CPA </Option>
              {allowedSupplierCSList?.map((supplier) => (
                      <Option key={supplier.supplierId}
                          value={supplier.supplierId}
                      >
                      {supplier.name}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="contractDatePicker" label="Start Date" className='mb-0'
            rules={[
              {
                required: true,
                message: "Required field",
              },
            ]}
            >
                <DatePicker placeholder='From Date' format={constants.DateFormat2}/>
						</Form.Item>
            {/* <Form.Item name="bilingDateEnd" label="Billing Start Date" className='mb-0'
            rules={[
              {
                required: true,
                message: "Required field",
              },
            ]}
            >
            <DatePicker placeholder='From Date' format={constants.DateFormat2}/>
						</Form.Item> */}
            <Form.Item
              name="contractPeriod"
              label="Contract Period"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select placeholder="Select Period" onChange={(e)=>onContractChange(e)}>
                <Option key="oneoff" value="One Off">One Off</Option>
                <Option key="monthly" value="Monthly">Monthly</Option>
                <Option key="twomonthly" value="TwoMonthly">Two Monthly</Option>
                <Option key="quaterly" value="Quarterly">Quarterly</Option>
                <Option key="sixmonthly" value="SixMonthly">Six Monthly</Option>
                <Option key="annually" value="Annually">Annually</Option>
                <Option key="twoyearly" value="TwoYearly">Two Yearly</Option>
                <Option key="threeyearly" value="ThreeYearly">Three Yearly</Option>                
              </Select>
            </Form.Item>
            <Form.Item
              name="billingPeriod"
              label="Billing Period"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select placeholder="Select Period" onChange={(e)=>{setBilling(e);resetInvoiveAmount();}} disabled={showBilling=="t"?true:false}>
                {contract==="Annually"?<>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  <Option key="quaterly" value="Quarterly">Quarterly</Option>
                  <Option key="sixmonthly" value="SixMonthly">Six Monthly</Option>
                  <Option key="annually" value="Annually">Annually</Option> 
                  </>:
                  contract==="Quarterly"?
                  <>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  <Option key="quaterly" value="Quarterly">Quarterly</Option>
                  </>:
                  contract==="TwoMonthly"?
                  <>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  <Option key="twomonthly" value="TwoMonthly">Two Monthly</Option>
                  </>:
                  contract==="SixMonthly"?
                  <>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  <Option key="quaterly" value="Quarterly">Quarterly</Option>
                  <Option key="sixmonthly" value="SixMonthly">Six Monthly</Option>
                  </>:
                  contract==="TwoYearly"?
                  <>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  <Option key="quaterly" value="Quarterly">Quarterly</Option>
                  <Option key="sixmonthly" value="SixMonthly">Six Monthly</Option>
                  <Option key="annually" value="Annually">Annually</Option>
                  <Option key="twoyearly" value="TwoYearly">Two Yearly</Option>
                  </>:
                  contract==="ThreeYearly"?
                  <>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  <Option key="quaterly" value="Quarterly">Quarterly</Option>
                  <Option key="sixmonthly" value="SixMonthly">Six Monthly</Option>
                  <Option key="annually" value="Annually">Annually</Option>
                  <Option key="threeyearly" value="ThreeYearly">Three Yearly</Option>
                  </>:
                  <>
                  <Option key="oneoff" value="One Off">One Off</Option>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  </>
                }
              </Select>
            </Form.Item>
            <Form.Item
              name="orderProductId"
              label="Order Product Id"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select placeholder="Select Product">
              {productsOrderList?.map((item) => (
                      <Option key={item.id}
                          value={item.id}
                      >
                      {item.productName}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="invoiceCurrency"
              label="Currency"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select placeholder="Select Currency">
                <Option key="USD" value="USD">USD</Option>
                <Option key="EUR" value="EUR">EUR</Option>
                <Option key="GBP" value="GBP">GBP</Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="contractAmount"
              label="Contract Amount"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <InputNumber min={0} onChange={(e)=>setInvoiceAmount(e)} className='w-full' placeholder="Amount"/>
            </Form.Item>    
            <Form.Item
              name="invoiceAmt"
              label="Invoice Amount"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <InputNumber disabled min={0} className='w-full' placeholder="Amount"/>
            </Form.Item>   
            <Form.Item name="orderInfo" label="Purchase Order Info."
            >
            {/* <TextArea
              autoSize={{
                minRows: 6,
                maxRows: 12,
              }}
              placeholder=""
            /> */}
            <Input placeholder='Order Info.'/>
           </Form.Item>  
           <Form.Item name="noteToIssuer" label="Note To Issuer:"
            >
            <Input placeholder='Note To Issuer:'/>
           </Form.Item>   
          </div>       
        </Form>
      </Modal>
		</div>
   </>
	);
};
export default OrdersAdminLiveContracts;
